/**
 * The HUD's logger, shared by the PixiHUDRenderer coordinator and every
 * extracted hud/<Name>.js element module (Phase 3D). It lives here rather than
 * in the coordinator so an element module can import it without importing the
 * coordinator back — that would be a cycle.
 */
import { ClientLogger } from '../../../logger/ClientLogger.js';

const pixiHudLoggerFallback = (() => {
  if (typeof window !== 'undefined' && window.console) {
    return window.console;
  }
  return { log: () => {}, warn: () => {}, error: () => {}, info: () => {} };
})();

export const pixiHudLogger = ClientLogger.getLogger('hud') || pixiHudLoggerFallback;
